import useHttp from './use-http';

const useDeliverables = () => {
    const getDeliverable = (briefId, deliverableId) => {
        const url = `/api/v1/activation-briefs/${briefId}/deliverables/${deliverableId}`;

        const { http } = useHttp();
        return http.get(url, {
            params: {
                expand: [
                    'last_approval_content_activity',
                    'last_approval_content_activity.content',
                    'last_approval_content_activity.content.files',
                    'approval_content_activity',
                    'approval_content_activity.content',
                    'approval_content_activity.content.files',
                    'content'
                ]
            }
        });
    };

    const postApprovalContent = (briefId, deliverableId, payload) => {
        const url = `/api/v1/activation-briefs/${briefId}/deliverables/${deliverableId}/content-submission`;

        const { http } = useHttp();
        return http.post(url, payload);
    };

    return {
        getDeliverable,
        postApprovalContent
    };
};

export default useDeliverables;
